import React from 'react';
import {navigateHook} from "../../../../../hooks/use-navigate.js";

const ReportContent = ({data, tableColumns}) => {
    const navigate = navigateHook();
    const rows = data ?? [];
    const columns = [
        {
            id: "dispatch_start",
            className: "w-[15%]",
            renderCell: element => element.dispatch_start ? <a onClick={() => navigate(`/despacho/dispatch/form/${element.dispatch_id}`, true)} className="report-link">{element.dispatch_start}</a> : ""
        },
        {id: "garrison_name", className: "w-[20%]", renderCell: element => element.garrison_name ?? ""},
        {id: "dt_fact", className: "w-[15%]", renderCell: element => element.dt_fact ?? ""},
        {id: "cause", className: "w-[15%]", renderCell: element => element.cause ?? "Não informado"},
        {id: "cameras", className: "w-[35%]", renderCell: element => element.cameras ?? ""}
    ];
    const visibleColumns = columns.filter(column => tableColumns?.[column.id]?.visible !== false);

    return (
        <>
            {visibleColumns.length === 0 && <div className="alert alert-info p-2 h6 text-center mt-[20px]!">Todas as colunas foram ocultadas.</div>}
            <table className={`table report-table ${visibleColumns.length === 0 ? "hidden" : ""}`}>
                <thead className="thead-background">
                    <tr className="bg-[#f6f6f6] text-left">
                        {visibleColumns.map(column => <th key={column.id} className={column.className}>{tableColumns?.[column.id]?.label ?? column.id}</th>)}
                    </tr>
                </thead>
                <tbody className="bg-white">
                    {rows.map((element, index) => <tr key={index} className="table-break-word">{visibleColumns.map(column => <td key={column.id} className={column.className}>{column.renderCell(element)}</td>)}</tr>)}
                </tbody>
            </table>
        </>
    );
};

export default ReportContent;